class AwakeAsleepIndicatorSection {

    constructor(node) {
        this.node = node;
        this.width = 0;
        this.spareTime = this.node.find('.spare-time');
        this.icon = this.node.find('i');
        this.time = this.spareTime.find('.hrs');
        this.text = this.spareTime.find('.text');
        $(window).on('resize.fittext orientationchange.fittext', this.onResize.bind(this));
    }

    updateHours(hours) {
        let width = Math.floor(hours/24.0 * 100);
        if(width === 0) {
            this.node.hide();
            this.node.css({width: ''+width+'%'});
        } else {
            this.node.show();
            this.node.animate({width: '' + width + '%'});
        }
        this.time.html('' + hours + 'h');
        this.width = width;
        this.onResize();
    }

    onResize() {
        let windowWidth = $(window).width();
        let thisWidthPx = this.width * windowWidth / 100;
        this.text.showIf(thisWidthPx > 144);
        this.icon.showIf(thisWidthPx > 80);
        this.spareTime.addClassIf('hideText', thisWidthPx <= 144);
        this.spareTime.addClassIf('hideIcon', thisWidthPx <= 80);
        this.spareTime.addClassIf('hideAll', thisWidthPx < 40);
    }
}

class AwakeAsleepIndicatorView {

    constructor() {
        this.occupiedTime = new AwakeAsleepIndicatorSection($('.timebar__daytime'));
        this.freeTime = new AwakeAsleepIndicatorSection($('.timebar__freetime'));
        this.asleepTime = new AwakeAsleepIndicatorSection($('.timebar__nighttime'));
    }
}
